<template>
<div class="layout-container" style="overflow: overlay" :class="{'bg-gradient-danger': error !== false, 'bg-gradient-info': error === false}">
<div class="page-container">

    <div class="container" :class="{'narrow': !share}">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-12 col-lg-10">
                <div class="cardbox mt-5" id="main-box">
                    <div class="cardbox-heading">
                        <div class="cardbox-title" v-if="share && share.team_info">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="text-md">Your shared files from {{ share.team_info.name }}</div>
                                <img v-if="share.team_info.logo_url && share.team_info.logo_url != ''" :src="share.team_info.logo_url" style="max-height: 48px" class="ml-2">
                            </div>
                            
                            <div style="clear:both"></div>
                        </div>
                    </div>
                    <div class="cardbox-body" id="main-box-body">

                        <!-- Error message -->
                        <div v-if="error" class="text-center">
                            <div class="alert alert-danger" style="display:inline-block;min-width: 60%" v-html="error"></div>
                        </div>

                        <div v-if="share_loading">
                            <i class="ion-load-c icon-lg spin text-info"></i>
                        </div>

                        <!-- Password input -->
                        <div v-if="share_password_needed && !share" class="text-center" style="width: 450px; margin: 0px auto; display:grid; grid-template-columns: 140px 1fr">
                            <i class="ion-lock-combination lock-icon"></i>
                            <div class="text-left d-flex align-items-center">
                                <form @submit.prevent="unlock_share()">
                                    <label for="share_password">Share Password</label>
                                    <div class="input-group">
                                        <input type="password" id="share_password" class="form-control" v-model.trim="share_password">
                                        <button type="submit" class="btn btn-gradient btn-success ml-2" :disabled="login_loading">Unlock <i v-if="login_loading" class="ion-load-c spin ml-1"></i></button>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <!-- Share contents -->
                        <div v-if="share">
                            <div v-if="share.message && share.message.length" class=" text-italic keep-whitespaces mb-4 text-center">
                                <CollapsibleText :note="share.message" class="bg-gray-lighter rounded p-2"  />
                            </div>

                            <div class="share-contents">

                                <div v-if="nav_stack && nav_stack.length > 1" class="d-flex align-items-center justify-content-middle mb-3">
                                    <div class="d-inline-block" v-for="(folder, index) in nav_stack" :key="folder.id">
                                        <button class="btn btn-flat btn-info" type="button" @click="navigate_to(folder)">
                                            <i v-if="folder.is_root" class="icon ion-home"></i>
                                            <span v-else>{{folder.name}}</span>
                                        </button>
                                        <span  v-if="index < nav_stack.length-1">&gt;</span>
                                    </div>
                                </div>

                                <div v-if="share.contents_loading">
                                    Loading... <i class="ion-load-c spin"></i>
                                </div>
                                <template v-else>
                                    <!-- Folder boxes -->
                                    <div class="row" v-if="folders?.length">
                                        <div class="col-12 col-md-6 col-lg-4 folder-box" v-for="folder in folders" :key="folder.id" @click="navigate_to(folder)">
                                            <div class="cardbox" :class="[ 'color-' + folder.color + '-400' ]" style="border-left: 4px solid;">
                                                <div class="cardbox-body" :title="folder.name">
                                                    <div class="d-flex justify-content-start align-items-center">
                                                        <i class="ion-folder mr-2" style="font-size: 25px; line-height: 25px"></i>
                                                        <span class="nowrap" style="overflow: hidden">{{ folder.name }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Files table -->
                                    <table class="table table-hover" v-if="files?.length">
                                        <thead>
                                            <th style="width: 10px"></th>
                                            <th class="text-left">Filename</th>
                                            <th class="d-none d-md-table-cell">Type</th>
                                            <th class="d-none d-md-table-cell">Size</th>
                                            <th v-if="share.download_limit" class="d-none d-md-table-cell">Downloads</th>
                                            <th class="d-none d-lg-table-cell">Uploaded</th>
                                            <th></th>
                                        </thead>
                                        <template v-if="files && files.length > 0" >
                                        <tbody v-for="file in files" :key="file.id">
                                            <tr :class="{'text-gray-light': file.loading, 'text-muted': share.download_limit && file.downloads_num >= share.download_limit }">
                                                <td><img :src="file.extension | filetype_img_src" /></td>
                                                <td class="text-left text-bold table-cell cell-full break-word">
                                                    <div v-if="share.download_limit && file.downloads_num >= share.download_limit" title="Cannot download this file any more, the download limit has been reached." class="c-not-allowed">
                                                        {{ file.name | remove_extension }} <i class="ion-alert-circled ml-1"></i>
                                                    </div>
                                                    <div v-else>
                                                        <a href="#" @click="download_file(file)" class="file_download_link">{{ file.name | remove_extension }}</a>
                                                        <span v-if="file.loading" class="text-muted ml-2">({{ file.loading.toFixed(1) }}%)</span>
                                                    </div>
                                                </td>
                                                <td class="nowrap text-gray-light text-sm d-none d-md-table-cell">
                                                    <span style="text-transform: uppercase">{{ file.extension }}</span>
                                                </td>
                                                <td class="nowrap text-gray-light text-sm d-none d-md-table-cell">
                                                    {{ file.size | format_bytes }}
                                                </td>
                                                <td v-if="share.download_limit" class="text-gray-light text-sm d-none d-md-table-cell text-center">
                                                    {{ file.downloads_num || 0 }} / {{ share.download_limit }} <i v-if="file.downloads_num >= share.download_limit" class="ion-alert-circled ml-1" />
                                                </td>
                                                <td class="nowrap text-gray-light text-sm d-none d-lg-table-cell">
                                                    <timestamp :timestamp="file.timestamp"></timestamp>
                                                </td>
                                                <td class="nowrap text-right">
                                                    <button v-if="file.cancel" @click="file.cancel()" class="btn text-sm btn-danger btn-flat" >CANCEL <i class="ion-close-round ml-1"></i></button>
                                                    <div v-else class="d-flex flex-column gap-1">
                                                        <button v-if="file.viewer" :disabled="share.download_limit && file.downloads_num >= share.download_limit" class="btn text-sm btn-flat" :class="[file.viewer.btn_class ]" @click.prevent="open_file(file)">{{ file.viewer.verb }} <i class="icon-lg ml-2" :class="file.viewer.icon_class"></i></button>
                                                        <button class="btn btn-info btn-gradient text-white ml-0" :disabled="share.download_limit && file.downloads_num >= share.download_limit" @click="download_file(file)"><i class="ion-arrow-down-a"></i><span class="ml-2">Download</span></button>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr class="file-loading" v-if="file.loading">
                                                <td colspan="7">
                                                    <div class="progress">
                                                        <div class="progress-bar progress-bar-striped progress-bar-animated"
                                                            role="progressbar" :aria-valuenow="Math.round(file.loading)" aria-valuemin="0" aria-valuemax="100" :style="{'width': Math.round(file.loading)+'%'}"></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        </template>
                                        <tbody v-if="files && files.length === 0">
                                            <tr>
                                                <td colspan="7" class="text-center">
                                                    <i>No files in this folder</i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="text-center text-italic">
                                        Empty folder
                                    </div>

                                </template>
                                
                            </div>
                        </div>
                    </div>
                    <div class="cardbox-footer d-flex align-items-center justify-content-between">
                        <div class="">
                            <locations
                                v-if="share && share.locations"
                                :locations="share.locations"
                                placement="top"
                                :team-name="share.team_info.name"
                                :circles="true"
                                :text-start="locations_text"></locations>
                        </div>
                        <a href="https://www.skyflok.com" target="_BLANK" rel="noopener"><img src="@/assets/img/skyflok_logo_black.png" height="32" /></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<modals-wrapper
    :no_shares="true"
    :no_copy_move="true"
    :no_file_viewer="!share"
    :no_download="!share"
/>

<global-alert />

</div>
</template>

<script>

import { ShareService } from '@/services/share-service.js'
import { Utils } from '@/helpers/utils.js'
import { NamespaceService } from '@/services/namespace-service';
import timestamp from '@/components/timestamp.vue'
import locations from '@/components/data-location-flags.vue'
import CollapsibleText from './collapsible-text.vue';
import globalAlert from './global-alert.vue';
import modalsWrapper from './modals-wrapper.vue';
import { bus, events } from '@/helpers/event_bus';

export default {

    components: {
        timestamp,
        locations,
        CollapsibleText,
        modalsWrapper,
        globalAlert
    },

    data(){
        return {
            error: false,
            login_loading: false,
            share_loading: false,
            share_key: null,
            share_password: null,
            share_password_needed: false,

            share: null,
            list_sort: { attr: 'name', asc: true },
            nav_stack: null
        }
    },

    computed: {
        files(){
            return this.share?.contents?.filter(en => en.entity_type === NamespaceService.ENTITY_TYPE_FILE) || []
        },

        folders(){
            return this.share?.contents?.filter(en => en.entity_type === NamespaceService.ENTITY_TYPE_FOLDER) || []
        },

        locations_text(){
            if(!this.share){ return "" }
            if(this.share.folder){
                // Default text is good here "this shared folder..."
                return null
            }
            let beginning = this.share.contents.length > 1 ? "These shared files" : "This shared file"
            return beginning + " is encrypted and distributed in the following "+this.share.locations.length+" locations, selected by the administrators of "+this.share.team_info.name+":"
        }
    },

    mounted(){
        document.title = "SkyFlok Share"

        // Parse share key
        this.share_key = Utils.parse_url_param('key', false, false)
        if(!this.share_key || this.share_key.length == 0){
            this.error = "Share Key not found in the URL! Please copy & paste the full link that you received into the address bar above!";
            return
        }
        
        // Try to retrieve the share password from session storage (after a page reload, without closing the tab)
        this.share_password = sessionStorage.getItem(`share-${this.share_key}`) || null
        
        // Try to load share, it may not be password protected
        this.load_share()

        // Increase downloads num when a file was downloaded
        bus.$on(events.FILE_DOWNLOADED, (file_id) => {
            this.increase_downloads_num(file_id)
        })
    },

    methods: {

        load_share(){
            this.share_loading = true
            ShareService.get_share_by_key(this.share_key, this.share_password, true)
                .then(res => {
                    this.error = false
                    this.on_share_loaded(res.body)
                })
                .catch(err => {
                    
                    if(err.status === 401){
                        // First load of a password protected share, show "password needed" UI
                        this.error = false
                        this.share_password_needed = true
                        return
                    }

                    // Show error message
                    this.parse_error(err)
                    
                })
                .finally(() => this.share_loading = false)
        },

        increase_downloads_num(file_id){
            let f = this.files.find(f => f.id === file_id)
            if(!f) return
            if(f.downloads_num === undefined) this.$set(f, 'downloads_num', 0)
            f.downloads_num++

            if(f.downloads_num >= this.share.download_limit){
                Utils.show_warning(`${f.name} reached the download limit, it cannot be downloaded any more!`)
            }
        },

        unlock_share(){
            // Load share contents after inputting the password
            this.share_loading = true
            this.login_loading = true
            ShareService.get_share_by_key(this.share_key, this.share_password, true).then(res => {
                this.error = false
                // Cache the share password so it can be injected by share-service
                sessionStorage['share-'+this.share_key] = this.share_password
                const share = res.body
                this.on_share_loaded(share)
            }).catch(err => {
                console.error(err);
                this.parse_error(err)
            }).finally(() => {
                this.login_loading = false
                this.share_loading = false
            })
        },

        on_share_loaded(share){
            // Called when the share is loaded (potentially after a password input)

            // Reset error
            this.error = false;

            // Show error for empty shares
            if(!share.contents || (share.folder === undefined && !share.contents) ){
                this.error = "Every file has been deleted from this share. Please contact the person who sent you the share link!"
                return
            }

            // If folder share, start nav stack
            if(share.folder && !this.nav_stack){
                this.nav_stack = [{
                    name: 'Home',
                    is_root: true,
                    id: share.folder
                }]
            }

            this.share = share
            this.init_folder_contents()
        },

        init_folder_contents(){
            // Set extension and viewer of files
            this.share.contents
                .filter(e => e.entity_type === NamespaceService.ENTITY_TYPE_FILE)
                .forEach(file => {
                    file.extension = Utils.get_file_extension(file.name)
                    file.mime_type = Utils.get_mime_type(file.extension)
                    file.viewer = Utils.get_file_viewer(file)
                    this.$set(file, 'loading', false)
                });

            // Set folder color
            this.share.contents
                .filter(e => e.entity_type === NamespaceService.ENTITY_TYPE_FOLDER)
                .forEach(folder => {
                    folder.color = Utils.string_to_color(folder.name)
                });

            // Sort contents by name
            Utils.sortByKeys(this.share.contents, 'name', false, true)
        },

        navigate_to(folder){

            // Maintain Nav Stack
            const i = this.nav_stack.findIndex(el => { return el.id === folder.id })
            if(i >= 0){
                // navigating up the stack
                this.nav_stack.splice(i+1)
            }
            else{
                // navigating down
                this.nav_stack.push({
                    name: folder.name,
                    id: folder.id
                })
            }

            this.$set(this.share, 'contents_loading', true)
            ShareService.get_subfolder_by_key(this.share_key, this.share_password, folder.id).then(res => {
                this.error = false
                this.share.contents_loading = false
                this.share.contents = res.body.contents
                this.init_folder_contents()

            }).catch(err => {
                console.error(err)
                this.share.contents_loading = false
                this.parse_error(err)
            })
        },

        open_file(file){
            const previewable_files = this.files.filter(f => f.viewer)
            bus.$emit(events.OPEN_FILE_VIEWER, {file, previewable_files})
        },

        download_file(file){
            bus.$emit(events.DOWNLOAD_FILE, {file})
        },

        parse_error(err){
            if(!err || !err.status){
                this.error = "Internal error in the Share Application."
                // TODO bug report
            }
            if(err.body && err.body.message) {
                this.error = err.body.message
            }
            else{
                let error_str = ""
                switch(err.status){
                    case 401: error_str = "Wrong password"; break
                    case 404: error_str = "We couldn't find the share you're looking for. Please copy & paste the full link that you received into the address bar above!"; break
                    case 403: error_str = "Sharing has been disabled for the Team who owns this Share."; break
                    case 410: error_str = "Share expired"; break
                    case 429: error_str = "This share is temporarily disabled"; break
                    default: error_str = "Temporary server error, please try again later. Sorry for the inconvenience."
                }
                this.error = error_str
            }
        },

    }
}
</script>

<style scoped>
.container{
    transition: max-width .3s ease-out
}
.container.narrow{
    max-width: 950px
}

@media(max-width: 992px){
    .cardbox#main-box{
        margin-top: 0px !important
    }
}

.share-contents{
    margin: auto 5%
}

@media(max-width: 768px){
    #main-box-body{
        padding: 8px
    }

    .share-contents{
        margin: auto 0px
    }

    .cardbox-title .text-md{
        font-size: 1.5rem !important
    }
}

.lock-icon{
    font-size: 100px;
    margin-right: 100px;
}

.table { display:table; width:100%; border-collapse:collapse; box-sizing:border-box; }
.table-cell { display:table-cell; }

.cell-full { max-width:1px; width:100%; }
.cell-ellipsis { overflow:hidden; white-space:nowrap; text-overflow:ellipsis; }
.cell-noWrap { white-space:nowrap; }


.file_download_link:not(.disabled):hover{
    text-decoration: underline;
    cursor: pointer;
}
.file_download_link{
    color: #59676b
}
.file_download_link.disabled{
    color: #a2a2a2
}

.theme-dark .file_download_link,
.theme-ironshard .file_download_link{
    color: #ddd
}


.table thead .sort_header{ cursor: pointer; }
.table thead th{
    font-size: 12pt;
    text-transform: uppercase;
    border: 0px
}

tr.file-loading,
tr.file-loading td { padding: 0px; margin: 0px; border: 0px }
tr.file-loading td .progress{ padding: 0px; height: 3px }
tr.file-loading td .progress-bar { height: 3px; margin: 0px; transition: width .2s linear }

.folder-box{ cursor: pointer; transition: all .3s ease; }
.folder-box:hover .cardbox{ box-shadow: 0px 5px 25px 0px rgba(123, 123, 123, 0.35) }

</style>
